const TELEDATA = {
  GET_TELEDATA_REPORT: 'risk/limits-new-teledata-report-get' as 'risk/limits-new-teledata-report-get',
}

export default TELEDATA
